// src/components/DesktopSideDrawer.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Grid,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ProductReviews from "./ProductReviews";
import SummaryDrawer from "./SummaryDrawer";
import useCanvasEvents from "../hooks/useCanvasEvents";

import theme from "../styles/themes/theme";

export default function DesktopSideDrawer() {
  const drawerTop = { xs: 164, sm: 174, md: 184 };
  const drawerWidth = { xs: "100%", sm: 340, md: 380 };

  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  const [drawerOpen, setDrawerOpen] = useState(isMdUp); // OPEN on md+

  // Auto-open on md+, nudge on mobile
  useEffect(() => {
    if (isMdUp) {
      setDrawerOpen(true);
    } else if (isSmDown) {
      setDrawerOpen(false); // closed but nudged
    }
  }, [isMdUp, isSmDown]);

  // Nudge logic in drawer translateValue
  const translateValue = drawerOpen
    ? "translateX(0)"
    : isSmDown
    ? "translateX(calc(100% - 48px))" // Nudge 48px on mobile
    : "translateX(calc(100% - 16px))"; // Normal peek on tablet
  return (
    <>
      {/* DRAWER */}
      <Box
        sx={{
          position: "fixed",
          right: 0,
          top: drawerTop,
          width: drawerWidth,
          height: "auto",
          maxHeight: {
            xs: `calc(100vh - ${drawerTop.xs}px)`,
            sm: `calc(100vh - ${drawerTop.sm}px)`,
            md: `calc(100vh - ${drawerTop.md}px)`,
          },
          bgcolor: "background.paper",
          zIndex: 1300,
          transform: translateValue,
          transition: "transform 0.4s ease",
        }}
      >
        <IconButton
          onClick={() => setDrawerOpen(!drawerOpen)}
          sx={{
            position: "absolute",
            left: -48,
            top: "50%",
            transform: "translateY(-50%)",
            bgcolor: "primary.main",
            color: "white",
          }}
        >
          <MenuIcon />
        </IconButton>
        <Box
          sx={{
            flex: 1,
            opacity: drawerOpen ? 1 : 0,
            pointerEvents: drawerOpen ? "auto" : "none",
          }}
        >
          <Box
            sx={{
              p: 3,
              pb: 1,
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid xs={12} md="auto">
                <Typography variant="h6" fontWeight="bold">
                  Order Summary
                </Typography>
              </Grid>
              <Grid item xs={12} md="auto">
                <ProductReviews />
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ flex: 1, overflowY: "auto", px: 3 }}>
            <SummaryDrawer open={true} onClose={() => {}} />
          </Box>
        </Box>
      </Box>
    </>
  );
}
